import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { menuRoles } from './core/constants/roles';
import { permissaoRotaGuard } from './core/guards/permissao-rota.guard';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'catalogo'
    },
    {
        path: 'nao-autorizado',
        loadChildren: () =>
            import('./pages/sem-autorizacao/sem-autorizacao.module').then(
                (m) => m.SemAutorizacaoModule
            )
    },
    {
        path: 'catalogo',
        loadChildren: () =>
            import('./pages/catalogo/catalogo.module').then((m) => m.CatalogoModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.conteudo.catalogo.visualizar
        }
    },
    {
        path: 'entidade',
        loadChildren: () =>
            import('./pages/entidade/entidade.module').then((m) => m.EntidadeModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.conteudo.entidade.visualizar
        }
    },
    {
        path: 'integracoes/gonexttx',
        loadChildren: () =>
            import('./pages/integracoes/go-next-tx/go-next-tx.module').then(
                (m) => m.GoNextTXModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.gonexttx.visualizar
        }
    },
    {
        path: 'integracoes/info-manuais',
        loadChildren: () =>
            import('./pages/info-manuais/info-manuais.module').then((m) => m.InfoManuaisModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.infomanuais.visualizar
        }
    },
    {
        path: 'integracoes/participantes',
        loadChildren: () =>
            import('./pages/integracoes/participantes/participantes.module').then(
                (m) => m.ParticipantesModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.participantes.visualizar
        }
    },
    {
        path: 'integracoes/recibos-manuais',
        loadChildren: () =>
            import('./pages/recibos-manuais/recibos-manuais.module').then(
                (m) => m.RecibosManuaisModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.recibosmanuais.visualizar
        }
    },
    {
        path: 'integracoes/registro-autoral',
        loadChildren: () =>
            import('./pages/integracoes/registro-autoral/registro-autoral.module').then(
                (m) => m.RegistroAutoralModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.registroautoral.visualizar
        }
    },
    {
        path: 'integracoes/registro-marcario',
        loadChildren: () =>
            import('./pages/integracoes/registro-marcario/registro-marcario.module').then(
                (m) => m.RegistroMarcarioModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.registromarcario.visualizar
        }
    },
    {
        path: 'integracoes/smusical',
        loadChildren: () =>
            import('./pages/integracoes/smusical/smusical.module').then((m) => m.SmusicalModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.smusical.visualizar
        }
    },
    {
        path: 'integracoes/vendas',
        loadChildren: () =>
            import('./pages/integracoes/vendas-internacionais/vendas-internacionais.module').then(
                (m) => m.VendasInternacionaisModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.vendasinternacionais.visualizar
        }
    },
    {
        path: 'parametros/atuacao',
        loadChildren: () => import('./pages/atuacao/atuacao.module').then((m) => m.AtuacaoModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/classificacao-indicativa',
        loadChildren: () =>
            import(
                './pages/parametros/classificacao-indicativa/classificacao-indicativa.module'
            ).then((m) => m.ClassificacaoIndicativaModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/coproducao',
        loadChildren: () =>
            import('./pages/parametros/coproducao/coproducao.module').then(
                (m) => m.CoproducaoModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/designacao',
        loadChildren: () =>
            import('./pages/parametros/designacao/designacao.module').then(
                (m) => m.DesignacaoModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/exclusividade',
        loadChildren: () =>
            import('./pages/parametros/exclusividade/exclusividade.module').then(
                (m) => m.ExclusividadeModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/formato',
        loadChildren: () => import('./pages/formato/formato.module').then((m) => m.FormatoModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/materia',
        loadChildren: () => import('./pages/materia/materia.module').then((m) => m.MateriaModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/orgao-registro',
        loadChildren: () =>
            import('./pages/orgao-registro/orgao-registro.module').then(
                (m) => m.OrgaoRegistroModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/pais',
        loadChildren: () => import('./pages/parametros/pais/pais.module').then((m) => m.PaisModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/status-registro-marcario',
        loadChildren: () =>
            import(
                './pages/parametros/status-registro-marcario/status-registro-marcario.module'
            ).then((m) => m.StatusRegistroMarcarioModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/titular',
        loadChildren: () =>
            import('./pages/parametros/titular/titular.module').then((m) => m.TitularModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'gestao-de-cargas/registro-autoral',
        loadChildren: () =>
            import(
                './pages/gestao-de-cargas/registro-autoral-carga/registro-autoral-carga.module'
            ).then((m) => m.RegistroAutoralCargaModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.gestaoDeCargas.registroautoral.visualizar
        }
    },
    {
        path: 'gestao-de-cargas/registro-marcario',
        loadChildren: () =>
            import(
                './pages/gestao-de-cargas/registro-marcario-carga/registro-marcario-carga.module'
            ).then((m) => m.RegistroMarcarioCargaModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.gestaoDeCargas.registromarcario.visualizar
        }
    },
    {
        path: 'gestao-de-cargas/vendas',
        loadChildren: () =>
            import('./pages/gestao-de-cargas/vendas-carga/vendas-carga.module').then(
                (m) => m.VendasCargaModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.integracoes.vendasinternacionais.visualizar
        }
    },
    {
        path: 'parametros/direito-licenciado',
        loadChildren: () =>
            import('./pages/direito-licenciado/direito-licenciado.module').then(
                (m) => m.DireitoLicenciadoModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/territorio',
        loadChildren: () =>
            import('./pages/territorio/territorio.module').then((m) => m.TerritorioModule),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    },
    {
        path: 'parametros/idioma-contato',
        loadChildren: () =>
            import('./pages/idioma-contato/idioma-contato.module').then(
                (m) => m.IdiomaContatoModule
            ),
        canActivate: [permissaoRotaGuard],
        data: {
            roles: menuRoles.itensMenu.parametros.parametro.visualizar
        }
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
